import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { RolesProvider } from './contexts/RolesContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<RolesProvider>
		<App />
	</RolesProvider>
);
    